/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  function validateVAT(input) {
    const value = input.value.trim();
  
    if (value === '') {
      // Se il campo è vuoto, nessun errore
      input.setCustomValidity('');
    } else {
      // Controlla che le prime due cifre siano alfanumeriche e le successive 11 siano numeriche
      const isValid = /^[A-Za-z0-9]{2}\d{11}$/.test(value);
      input.setCustomValidity(isValid ? '' : localizedStrings.vat.error);
    }
  
    input.reportValidity(); // Mostra o rimuove il messaggio di validazione
  }  
  
  function validateCF(input) {
    const value = input.value.trim();
  
    if (value === '') {
      // Se il campo è vuoto, nessun errore
      input.setCustomValidity('');
    } else {
      const isValid = /^[A-Za-z0-9]{16}$/.test(value);
      input.setCustomValidity(isValid ? '' : localizedStrings.cf.error);
    }
  
    input.reportValidity();
  }  
  
  function validatePEC(input) {
    const value = input.value.trim();
  
    if (value === '') {
      // Se il campo è vuoto, nessun errore
      input.setCustomValidity('');
    } else {
      const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      input.setCustomValidity(isValid ? '' : localizedStrings.pec.error);
    }
  
    input.reportValidity();
  }
  
  function validateSDI(input) {
    const value = input.value.trim();
  
    if (value === '') {
      // Se il campo è vuoto, nessun errore
      input.setCustomValidity('');
    } else {
      const isValid = /^[A-Za-z0-9]{7}$/.test(value);
      input.setCustomValidity(isValid ? '' : localizedStrings.sdi.error);
    }
  
    input.reportValidity();
  }  
  
  document.addEventListener('DOMContentLoaded', () => {
    // VAT Field
    const vatInput = document.getElementById('p-iva');
    vatInput.addEventListener('input', () => validateVAT(vatInput)); // Validazione dinamica
    vatInput.addEventListener('blur', () => validateVAT(vatInput)); // Validazione su blur

    // CF Field
    const cfInput = document.getElementById('cf');
    cfInput.addEventListener('input', () => validateCF(cfInput));
    cfInput.addEventListener('blur', () => validateCF(cfInput));

    // PEC Field
    const pecInput = document.getElementById('pec');
    pecInput.addEventListener('input', () => validatePEC(pecInput));
    pecInput.addEventListener('blur', () => validatePEC(pecInput));

    // SDI Field
    const sdiInput = document.getElementById('sdi');
    sdiInput.addEventListener('input', () => validateSDI(sdiInput));
    sdiInput.addEventListener('blur', () => validateSDI(sdiInput));
  });
  
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
